/**
 * PopupListContainer
 * --
 */
import React, { useState, useEffect } from 'react';
import MessageAlert from 'utils';
import { PopupApi } from 'api';
import PopupListPresenter from './PopupListPresenter';
import { FileManager } from 'utils/FileManager';

const initData = {
  popup_name: '',
  popup_type: 'ALL',
  is_show: 'Y',
  popup_start_date: '',
  popup_end_date: '',
  render_url: '',
  is_new_window: 'N',
};
/**----------------------------------------
 * [Component] 총관리자 > 사이트관리 > 팝업관리: 컨테이너
 * ----------------------------------------
 */
const PopupListContainer = ({ onDeleted, onSaved }) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [isOpened, setIsOpened] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [modalType, setModalType] = useState('CREATE');
  // 파일
  const [files, setFiles] = useState(null);
  //
  const [formData, setFormData] = useState(initData);

  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /**
   * 모달 핸들러
   * --
   */
  const handleOpenModal = (t = 'CREATE', d) => {
    const type = t.toLocaleUpperCase();
    setIsOpened(true);
    setModalType(type);
    setModalData(d);
  };

  /**--------------------
   * 데이터 조회
   * --------------------
   */
  const getData = async () => {
    setLoading(true);
    try {
      const { status, message, data } = await PopupApi.getPopups();
      if (status !== 200) throw { message };

      setTimeout(() => {
        setData(data);
        setLoading(false);
      }, 750);
    } catch (e) {
      setLoading(false);
      MessageAlert.error(e.message);
    }
  };

  /**--------------------
   * 삭제
   * --------------------
   */
  const onDelete = async (key) => {
    if (
      !window.confirm(
        '팝업을 삭제하시겠습니까?\n삭제한 팝업 데이터는 복구가 불가능합니다.'
      )
    ) {
      return;
    }
    setLoading(true);
    try {
      const { status, message } = await PopupApi.deletePopup(key);
      if (status !== 200) throw { message };
      setIsOpened(false);
      setModalData(null);

      setTimeout(() => {
        setData(data);
        setLoading(false);
        onDeleted(key);
        getData();
      }, 750);
      MessageAlert.success('성공적으로 삭제되었습니다.');
    } catch (e) {
      setLoading(false);
      MessageAlert.error(e.message);
    }
  };

  /**
   *
   * --
   */
  const onSave = async () => {
    try {
      let fileName = '';
      if (!formData?.popup_content && files) {
        const file = files;

        // 예외처리
        if (file.name.length > 50) {
          MessageAlert.info(
            `파일명은 50자를 초과할 수 없습니다. 파일명을 수정해주세요.`
          );
          return;
        }

        if (!formData.popup_name) {
          MessageAlert.info(`팝업 제목을 입력해주세요!`);
          return;
        }

        if (!formData.popup_start_date) {
          MessageAlert.info(`팝업 노출 시작일은 필수입니다!`);
          return;
        }

        if (!formData.popup_end_date) {
          MessageAlert.info(`팝업 노출 종료일은 필수입니다!`);
          return;
        }

        const fn = file.name.split('.');
        const exp = fn[fn.length - 1];

        // 파일 등록 처리
        const upload = await FileManager.upload(`popup`, file);
        if (upload.status !== 200) {
          MessageAlert.warning('파일 등록에 실패하였습니다.');
          return;
        }

        fileName = upload.data.file_name;
      }

      // API
      const newData = {
        ...(modalType === 'UPDATE' ? { popup_id: formData.popup_id } : {}),
        popup_name: formData.popup_name,
        popup_type: 'PC',
        is_show: formData.is_show,
        popup_start_date: formData.popup_start_date,
        popup_end_date: formData.popup_end_date,
        popup_content: formData?.popup_content
          ? formData?.popup_content
          : `<img width="100%"  src="${process.env.REACT_APP_STORE_URL}/${fileName}" />`,
        render_url: formData.render_url,
        is_new_window: formData.is_new_window,
      };

      const mutate = {
        CREATE: PopupApi.createPopup,
        UPDATE: PopupApi.updatePopup,
      };

      const { status, message } = await mutate[modalType](newData);
      if (status !== 200) throw { message };

      MessageAlert.success('팝업이 등록되었습니다!');
      setFormData(initData);
      setIsOpened(false);
      setModalData(null);
      setFiles(null);
      getData();
    } catch (e) {
      setLoading(false);
      MessageAlert.error(e.message);
    }
  };

  /* ===== HOOKS ===== */
  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (!isOpened) {
      setFormData(initData);
      setFiles(null);
    }
  }, [isOpened]);

  /* ===== RENDER ===== */
  return (
    <PopupListPresenter
      {...{
        loading,
        data,
        onDelete,
        isOpened,
        modalData,
        modalType,
        setIsOpened,
        setModalData,
        setModalType,
        handleOpenModal,
        setFiles,
        onSave,
        formData,
        setFormData,
        setLoading,
        files,
      }}
    />
  );
};

PopupListContainer.defaultProps = {
  onSaved() {},
  onDeleted() {},
};
export default PopupListContainer;
